import React, { useState, useRef, useEffect } from 'react'
import Webcam from 'react-webcam'
import SelectImageModule from './SelectImage.module.scss'
import IconButton from '@mui/material/IconButton'
import CancelIcon from '@mui/icons-material/Cancel'
import ModalForPicture from '../Bubble/ModalForPicture'

function SelectImage({ questionData, onValueChange }) {
  const [capturedImages, setCapturedImages] = useState([])
  const [isCameraOpen, setIsCameraOpen] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  const [isHovering, setIsHovering] = useState(null) // ホバー状態の管理
  const webcamRef = useRef(null)

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera
    if (/android|iphone|ipad|iPod|iPad|iPhone|Android/i.test(userAgent)) {
      setIsMobile(true)
    }
  }, [])

  const handleImageUpload = (files) => {
    const newImages = Array.from(files).map((file) => ({
      id: Date.now() + Math.random(), // ユニークなIDを生成
      url: URL.createObjectURL(file),
      file
    }))
    setCapturedImages((prev) => [...prev, ...newImages])
    console.log('[...capturedImages, ...newImages]', [...capturedImages, ...newImages])
    onValueChange([...capturedImages, ...newImages]) // Update parent with all images
  }

  const handleCapture = () => {
    const imageSrc = webcamRef.current.getScreenshot()
    const file = dataURLtoFile(imageSrc, `image_${Date.now()}.jpg`)
    const newImage = { id: Date.now(), url: imageSrc, file }
    setCapturedImages((prev) => [...prev, newImage])
    onValueChange([...capturedImages, newImage])
    setIsCameraOpen(false)
  }

  const handlePaste = (event) => {
    const clipboardItems = event.clipboardData.items
    const imageItems = Array.from(clipboardItems).filter((item) => item.type.startsWith('image/'))

    if (imageItems.length > 0) {
      const files = imageItems.map((item, index) => {
        const file = item.getAsFile()
        const newFileName = `image_${Date.now()}_${index}.jpg`
        const renamedFile = new File([file], newFileName, { type: file.type })
        return renamedFile
      })
      handleImageUpload(files)
    }
  }

  const dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(',')
    const mime = arr[0].match(/:(.*?);/)[1]
    const bstr = atob(arr[1])
    let n = bstr.length
    const u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], filename, { type: mime })
  }

  const removePreview = (indexToRemove) => {
    const urlToRemove = capturedImages[indexToRemove].url
    URL.revokeObjectURL(urlToRemove)
    const updatedImages = capturedImages.filter((_, index) => index !== indexToRemove)
    setCapturedImages(updatedImages)
    onValueChange(updatedImages)
    setIsHovering(null)
  }

  return (
    <div className={SelectImageModule['upload-container']}>
      <div onPaste={handlePaste} className={SelectImageModule['upload-sub-container']}>
        <p className={SelectImageModule['attachment']}>ここにファイルをアップロード</p>
        <label htmlFor={`file_upload${questionData.order}`} className={SelectImageModule['upload']}>
          画像を選択
        </label>
        <input
          id={`file_upload${questionData.order}`}
          type="file"
          accept="image/*"
          multiple
          onChange={(e) => handleImageUpload(e.target.files)}
          style={{ display: 'none' }}
        />
        {!isMobile && (
          <>
            <button onClick={() => setIsCameraOpen(!isCameraOpen)} className={SelectImageModule['upload']}>
              {isCameraOpen ? 'カメラを閉じる' : 'カメラを開く'}
            </button>
            {isCameraOpen && (
              <div>
                <Webcam audio={false} ref={webcamRef} screenshotFormat="image/jpeg" width={320} height={240} />
                <button onClick={handleCapture} className={SelectImageModule['upload']}>
                  撮影
                </button>
              </div>
            )}
          </>
        )}
      </div>
      <div>
        {capturedImages.map((image, index) => (
          <div
            key={image.id}
            style={{ position: 'relative', display: 'inline-block', margin: 4 }}
            onMouseEnter={() => setIsHovering(index)}
            onMouseLeave={() => setIsHovering(null)}
          >
            <img
              src={image.url}
              alt="Selected or Captured"
              className={SelectImageModule['image-preview']}
              style={{ width: 120, height: 90, borderRadius: 6 }}
            />
            {isHovering === index && (
              <IconButton
                size="small"
                style={{
                  position: 'absolute',
                  top: 4,
                  right: 4,
                  backgroundColor: 'white',
                  boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.2)'
                }}
                onClick={() => removePreview(index)}
              >
                <CancelIcon fontSize="small" style={{ color: 'red' }} />
              </IconButton>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default SelectImage
